import styled from 'styled-components'

import Alert from '@mui/material/Alert'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'

export const StyledAlert = styled(Alert)`
  display: flex;
  width: 320px;
  padding: 6px 16px;
  align-items: flex-start;
  border-radius: 4px;
  background: var(
    --light-success-shades-190-p,
    linear-gradient(0deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.9) 100%),
    #2e7d32
  );
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`
export const StyledCloseButton = styled(IconButton)`
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.46px;
  text-transform: uppercase;
  color: var(--light-success-shades-160-p, #2e7d32);
`
export const StyledTitle = styled(Typography)`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: var(--light-success-shades-160-p, #2e7d32);
`
export const StyledMessage = styled(Typography)`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: var(--light-success-shades-160-p, #2e7d32);
`
